// extracted by mini-css-extract-plugin
export default {"backdrop":"Loader_backdrop__g3pnG","loader":"Loader_loader__qwtVO","rotation":"Loader_rotation__kqAvg","rotationBack":"Loader_rotationBack__ogKTb"};